import { NgModule } from '@angular/core';
import { CustomerManageService } from '../customer/shared/customer-manage.service';
import { IndividualDetailService } from '../customer/detail/individual-detail.service';
import { CredentialTypeService } from './services/credential-type.service';
import { LicenseClassTypeService } from './services/license-class-type.service';
import { AttributeTypeService } from './services/attribute-type.service';
import { CredentialTypeAttributeTypeMapService } from './services/credential-type-attribute-type-map.service';
import { DriverCredentialService } from './services/driver-credential.service';
import { CredentialIssuanceService } from './services/credential-issuance.service';
import { CredentialIssuanceApplicationService } from './services/credential-issuance-application.service';
import { RequirementApplicationService } from './services/requirement-application.service';
import { ExaminationService } from './services/examination.service';
import { RequirementWaiveService } from './services/requirement-waive.service';
import { DocumentVerificationService } from './services/document-verification.service';
import { DriverPrivilegeService } from './services/driver-privilege.service';
import { ExternalCheckService } from './services/external-check.service';
import { DriverTransactionService } from './services/driver-transaction.service';
import { DriverRestrictionService } from './services/driver-restriction.service';
import { PostFinalizeService } from './services/post-finalize.service';
import { DriverGemviewService } from './services/driver-gemview.service';
import { QuestionsCaptureCommunicationService } from './services/questions-capture-communication.service';

@NgModule({
    declarations: [
    ],
    providers: [
        CustomerManageService,
        IndividualDetailService,
        CredentialTypeService,
        DriverCredentialService,
        LicenseClassTypeService,
        CredentialIssuanceService,
        CredentialIssuanceApplicationService,
        AttributeTypeService,
        CredentialTypeAttributeTypeMapService,
        RequirementApplicationService,
        ExaminationService,
        RequirementWaiveService,
        DocumentVerificationService,
        DriverPrivilegeService,
        ExternalCheckService,
        DriverTransactionService,
        DriverRestrictionService,
        PostFinalizeService,
        DriverGemviewService,
        QuestionsCaptureCommunicationService
    ],
    imports: [
    ],
    exports: [
    ]
})
export class DriverCoreModule { }
